export default __webpack_public_path__ + "static/media/art-tat.73a1e948.svg";